<template>
  <el-button  >
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  name: "yzButton0"
}
</script>

<style scoped>

</style>
